<template>
    <div>
        <v-tabs dark background-color="secondary">
            <v-tab>
                ΚΤΗΡΙΟ
            </v-tab>
            <v-tab>
              <wnl-text>ΑΝΥΨΩΤΙΚΆ</wnl-text>
                ({{building.ProjectCount}})
            </v-tab>
            <v-tab v-if="userDetails.Allows.ShowDeptsMoves">
                AN. ΚΙΝΗΣΕΙΣ ΠΕΛΑΤΗ
            </v-tab>
            <v-tab-item class="pa-4">
                <building-details :building="building"> </building-details>
            </v-tab-item>
            <v-tab-item>
                <v-card>
                    <v-row>
                        <v-col lg="2" sm="12"  style="border-right:1px solid #b2b2b2;">
                            <expandable flat desktop-toolbar-title :expandable="isMobile">
                                <template v-slot:toolbar-title>
                                    <v-toolbar-title style="font-weight: bolder; font-size: 1.5em;"> <wnl-text>Ανελκυστήρες</wnl-text> </v-toolbar-title>
                                </template>
                                <template v-slot:content>
                                    <v-list color="transparent" :height="!isMobile?'75vh':''">
                                        <v-list-item-group :value="activeProject">
                                            <v-list-item @click="projectClick(index)" link
                                                         v-for=" (elevator,index) in building.Projects">
                                                <v-list-item-content>
                                                    <v-list-item-title>{{elevator.ProjectName}}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </template>
                            </expandable>
                        </v-col>
                        <v-col lg="10" sm="12">
                            <project-card :key="activeProject" :project="building.Projects[activeProject]"/>
                        </v-col>
                    </v-row>
                </v-card>
            </v-tab-item>
            <v-tab-item v-if="userDetails.Allows.ShowDeptsMoves" class="pa-4">
                <partner-dept-moves :partner-id="building.Partner_ID"/>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    import {BranchDetails} from "../../../wl-core/api/classes/BranchDetails";
    import ProjectCard from "../../Projects/views/ProjectCard";
    import BuildingDetails from "../views/BuildingDetails";
    import {mapGetters} from "vuex";
    import PartnerDeptMoves from "../../Financial/components/PartnerDeptMoves";
    import Expandable from "../../../wl-core/components/Expandable";
    import WnlText from "@/wl-unit-text/WnlText";

    export default {
        name: "BuildingCard",
        components: {WnlText, Expandable, PartnerDeptMoves, BuildingDetails, ProjectCard},
        props: {building: BranchDetails},
        data: () => ({
            activeProject: 0
        }),
        computed:{
          ...mapGetters([
              "isMobile",
              "userDetails"
          ])
        },
        methods: {
            projectClick(index) {
                this.activeProject = index
            }
        }
    }
</script>

<style scoped>

</style>
